import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-terms-condition-page',
    templateUrl: './terms-conditions.component.html'
})
export class TermsConditionsComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService
    ) { }
    italian = false;
    english = false;
    ngOnInit() {
        this.italian = (this.translate.currentLang === 'it');
        this.english = (this.translate.currentLang === 'en');
    }
}
